import { Entity } from '@backstage/catalog-model';
import { Component } from './types/InsightsTypes';
/**
 * Function for fetching entity components
 * @param entity - The entity to fetch components for
 * @param catalogApi - The catalog API to use for fetching components
 * @param filterMode - The mode to use for filtering (exclude or include)
 * @param filter - The filter to apply to the components
 */
export const getEntityComponents = async (
  entity: Entity | undefined,
  catalogApi: any,
  filterMode: 'exclude' | 'include',
  filter: string[] = [],
): Promise<{ entityComponents: Component[]; entityComponentIds: string[] }> => {
  if (!entity) return { entityComponents: [], entityComponentIds: [] };

  // Instead of using entity.relations (which is limited to 100),
  // query the catalog API for ALL components that have a partOf relationship to this entity
  const entityRef = `${entity.kind}:${entity.metadata.namespace || 'default'}/${entity.metadata.name}`;

  const response = await catalogApi.getEntities({
    filter: {
      kind: 'Component',
      'relations.partOf': [entityRef],
    },
  });

  const results: Entity[] = response.items || [];

  const allComponents = results.map(
    targetEntity =>
      ({
        id: String(targetEntity.metadata?.name),
        name: targetEntity.metadata?.title,
        owner: String(targetEntity.spec?.owner),
        type: String(targetEntity.spec?.type),
        lifecycle: String(targetEntity.spec?.lifecycle),
        description: targetEntity.metadata?.description,
      }) as Component,
  );

  // Filter components based on filterMode
  const entityComponents = allComponents.filter((component: Component) => {
    if (!filter || filter.length === 0) return true;
    const kind = component.type.toLowerCase();
    const matchesFilter = filter.some(
      filterValue => kind === filterValue.toLowerCase(),
    );
    return filterMode === 'exclude' ? !matchesFilter : matchesFilter;
  });

  // Extract component IDs
  const entityComponentIds = entityComponents.map(component => component.id);

  return { entityComponents, entityComponentIds };
};
